import { useSuperAdminRoles } from "../../../context/SuperAdmin/RolesContext";
import { Spinner } from "../../Loading/Spinner";
import { Grid } from "@mui/material";
import HeadersRolesTable from "./HeadersRolesTable";
import RolesTable from "./RolesTable";
import { useAuthContext } from "../../../hooks/Auth";

const RolesPanel = () => {
  const { isLoadingRoles } = useSuperAdminRoles();
  const { canAccess } = useAuthContext();

  if (isLoadingRoles) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <>
      {/* Crear plan */}
      {canAccess("create:role") && <Grid item>
        <HeadersRolesTable />
      </Grid>}

      {/* Tabla de roles */}
      <Grid item>
        <RolesTable />
      </Grid>
    </>
  );
};

export default RolesPanel;
